import { render } from "./DataLoad.vue?vue&type=template&id=065bebd2&scoped=true"
import script from "./DataLoad.vue?vue&type=script&lang=js"
export * from "./DataLoad.vue?vue&type=script&lang=js"

import "./DataLoad.vue?vue&type=style&index=0&id=065bebd2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065bebd2"]])

export default __exports__